import React from 'react';
import Avatar from '@sv-support-sdk/ui-components/src/components/Media/Avatar';
import Dropdown from '@sv-support-sdk/ui-components/src/components/Controls/Dropdown';

import Button from '../ui/Controls/Button';
import Options from '../Lists/Options';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setActiveModal } from '../../store/slices/modals';
import { CLOSE_MODAL } from '../../constants/modals';
import { chatAgentSelector, chatIdSelector } from '../../store/selectors/chat';
import { $l } from '../../locales';
import { download, messagesToSend } from '../../helpers/download';
import { chatMessages } from '../../store/selectors/messages';
import { setChatOpenState } from '../../store/actions/chat';

import css from './style.module.scss';
import setQaAttribute from '../../helpers/setQaAttribute';
import {
  CHAT_HEADER,
  CHAT_HEADER_MENU,
  CLOSE_CHAT_BUTTON,
  DOWNLOAD_CHAT_BUTTON,
  HIDE_CHAT_BUTTON,
} from '../../constants/qaAttributes';

interface IHeaderOption {
  label: string;
  action: () => void;
}

const ChatHeader = () => {
  const dispatch = useAppDispatch();
  const agent = useAppSelector(chatAgentSelector);
  const chatId = useAppSelector(chatIdSelector);
  const messages = useAppSelector(chatMessages);

  // todo: add qaId to sv-actions
  const menuOptions = [
    {
      label: $l('DOWNLOAD_CHAT'),
      qaId: DOWNLOAD_CHAT_BUTTON,
      action: () => {
        download(`${$l('CHAT')}-${$l('CONVERSATION')}-${chatId || ''}`, messagesToSend(messages));
      },
    },
    {
      label: $l('HIDE_CHAT'),
      qaId: HIDE_CHAT_BUTTON,
      action: () => {
        dispatch(setChatOpenState(false));
      },
    },
  ];

  if (chatId) {
    menuOptions.push({
      label: $l('CLOSE_CHAT'),
      qaId: CLOSE_CHAT_BUTTON,
      action: () => {
        dispatch(setActiveModal(CLOSE_MODAL));
      },
    });
  }

  const onSelect = (option: IHeaderOption) => {
    option.action();
  };

  return (
    <div className={css.chat__header} {...setQaAttribute(CHAT_HEADER)}>
      {agent ? (
        <>
          <Avatar
            img={
              agent.img
                ? {
                    src: agent.img,
                    alt: agent.name,
                  }
                : undefined
            }
            icon={!agent.img ? 'colored--32--avatar' : undefined}
            className="indent-xs-right"
          />
          <div className={css.chat__headerDetails}>
            <div className={css.chat__headerTitle}>{agent.name}</div>
            <div className={css.chat__headerSubtitle}>{$l('CHAT_SUBHEADER')}</div>
          </div>
        </>
      ) : (
        <div className={css.chat__headerDetails}>
          <div className={css.chat__headerTitle}>{$l('CHAT_HEADER')}</div>
        </div>
      )}
      <Dropdown
        options={menuOptions}
        trackBy="label"
        label="label"
        onSelect={onSelect}
        width="inherit"
        value={null}
        placement="right"
        // @ts-expect-error - expected error
        OptionsComponent={Options}
      >
        <Button
          icon="24--more-vertical"
          iconSize="24"
          radius="circle"
          shape="square"
          size="small"
          variant="icon"
          {...setQaAttribute(CHAT_HEADER_MENU)}
        />
      </Dropdown>
    </div>
  );
};

export default ChatHeader;
